import { render, staticRenderFns } from "./TreatmentListEditForm.vue?vue&type=template&id=d8f5761a&scoped=true&lang=pug&"
import script from "./TreatmentListEditForm.vue?vue&type=script&lang=js&"
export * from "./TreatmentListEditForm.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentListEditForm.vue?vue&type=style&index=0&id=d8f5761a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f5761a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VDivider,VForm,VIcon,VRow,VSkeletonLoader,VSpacer,VTextField})
